// import SingleNews from '@/views/news/SingleNews'
// import NewsHome from '@/views/news/NewsHome'
// import NewsList from '@/views/news/NewsList'
// import NewsCreate from '@/views/news/NewsCreate'

import ReportHome from '@/views/reports/ReportHome'
import ReportList from '@/views/reports/ReportList'
import ReportCreate from '@/views/reports/ReportCreate'
import Report from '@/views/reports/Report'

export default {
  path: '/rapporter',
  component: ReportHome,
  children: [
    {
      path: ':section',
      name: 'ReportsList',
      props: true,
      component: ReportList,
      children: [
        {
          path: 'ny',
          name: 'ReportCreate',
          props: true,
          component: ReportCreate,
        },
      ],
    },

    {
      path: ':section/:id',
      name: 'SingleReport',
      props: true,
      component: Report,
    },
  ],
}
